<template>

    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @reset="$gjReset"
            @query="$gjNoticeQuery"
        >
          <gj-country-server-select
              v-model="filter.countryMarketValue"
          ></gj-country-server-select>
          <gj-select
              v-model="filter.status"
              :options="[
                {id: 1, text: '在线'},
                {id: 0, text: '离线'}
              ]"
              placeholder="状态"
          ></gj-select>
          <template #right>
            <gj-tool-group help>
              <template #before>
                <gj-link :href="helpUrl" target="_blank">如何安装积加云插件？</gj-link>
              </template>
            </gj-tool-group>
          </template>
        </app-filter-group>
      </template>
      <template #table>
        <gj-table
            name="exchange-rate"
            adaptParent
            :data="tableData"
            :pagination="pagination"
            :loading="loading"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
            :columns="columns">
        </gj-table>
      </template>
      <template #base-content>
          <new-user-guide v-if="userGuideState" ref="newUserGuide" ></new-user-guide>
       </template>
    </app-base-main>
</template>

<script>
  import {queryMixin, userGuideMixin, selectionMixin } from "../../../../minxins";
  import {getCloudStatus} from "../../../../api/tool";
  import NewUserGuide from "./components/new-user-guide";
  import {isMeaningful} from "../../../../utils/common";

  export default {
    name: "app-cloud-plugin-status",
    components: { NewUserGuide },
    mixins: [queryMixin, selectionMixin, userGuideMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'server', header: '店铺', field: 'marketName', minWidth: '70px'},
          {id: 'country', header: '国家', field: 'countryCode', minWidth: '70px'},
          {id: 'status', header: '状态', field: 'option(plain):status', help: '每小时更新一次', minWidth: '70px', options: [
              {id: 1, text: '在线', color: '#5bbd2a'},
              {id: 0, text: '离线', color: '#888'},
            ]},
          {id: 'type', header: '类型', field: 'option:type', minWidth: '70px', options: [
              {id: 0, text: '浏览器插件'}
            ]},
          {id: 'updateDate', header: '更新时间', field: 'updateTime', minWidth: '70px'},
        ],
        filter: {
          countryMarketValue: null,
          status: null,
        },
        notStorage: true,
        helpUrl: 'http://help.gerpgo.com/web/#/26?page_id=603'
      }
    },
    mounted() {
      this.isSetUserGuideStep()
    },
    activated() {
      this.isSetUserGuideStep()
    },
    methods: {
      isSetUserGuideStep() {
        if(this.userGuideState && this.$route.query.step && this.$route.query.step == 3) {
          let step = +this.$route.query.step
          this.userGuideNextStep(step)
        }
      },
      $gjQuery() {
        this.loading = true;
        getCloudStatus({
          model: {
            status: this.filter.status,
            marketIds: isMeaningful(this.filter.countryMarketValue) ? this.filter.countryMarketValue.marketIds : null,
            countryCodes: isMeaningful(this.filter.countryMarketValue) ? this.filter.countryMarketValue.countryIds : null,
          },
          ...this.querySort,
          ...this.queryPagination,
        }).then((data) => {
          this.pagination = this.getPagination(data);
          this.tableData = data.records;
        }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            countryMarketValue: null,
            status: null,
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>



